import { render, staticRenderFns } from "./subjectlist.vue?vue&type=template&id=446a866e&scoped=true&"
import script from "./subjectlist.vue?vue&type=script&lang=js&"
export * from "./subjectlist.vue?vue&type=script&lang=js&"
import style0 from "./subjectlist.vue?vue&type=style&index=0&id=446a866e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446a866e",
  null
  
)

export default component.exports